import type {
  ConfigurationResourceRemoteKeyInjectionBasicApi,
  KeySetReferenceResourceListResponseApi,
  OrganizationEnvironmentKeySetsApi,
  OrganizationEnvironmentResourceReadApi,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { RkiKeySetItem } from '@ingenico/react-configuration-generator';
import { RkiKeySetChipMode } from '@ingenico/react-configuration-generator';
import { isEmpty, toArray, toString } from 'lodash-es';
import type { OrganizationEnvironmentKeysetResponse } from '../../models/organizationEnvironment.model';
import type { RkiConfigurationFormulary, RkiDeviceGroupsName } from '../../models/rkiConfiguration.model';

export function mapConfigurationResourceRemoteKeyInjectionApiToRkiConfigurationV2({
  data,
}: KeySetReferenceResourceListResponseApi): RkiDeviceGroupsName {
  return (data ?? []).map(({ keySet }) => keySet);
}

export function mapOrganizationEnvironmentKeysetsToRkiNames({
  keysets,
}: OrganizationEnvironmentKeysetResponse): RkiDeviceGroupsName {
  return keysets.map(({ name }) => name);
}

export function mapConfigurationResourceRemoteKeyInjectionApiToNameWithIdList(
  rkiConfiguration: KeySetReferenceResourceListResponseApi,
): string[] {
  return toArray(
    rkiConfiguration.data?.reduce(
      (acc: string[], item) => [...acc, ...(acc.includes(item.keySet) ? [] : [item.keySet])],
      [] as string[],
    ),
  );
}

export function getRkiConfigurationFormInput({
  domain,
  environment,
}: ConfigurationResourceRemoteKeyInjectionBasicApi): RkiConfigurationFormulary {
  return {
    domain: toString(domain),
    environment: toString(environment),
    submissionMethod: isEmpty(domain) && isEmpty(environment) ? 'POST' : 'PATCH',
  };
}

export function mapEnvironmentResponseToId(
  response: OrganizationEnvironmentResourceReadApi | null | undefined,
): string | null {
  return response?.id ?? null;
}

export function mapKeySetListToRkiItems(response: OrganizationEnvironmentKeySetsApi): RkiKeySetItem[] {
  return (response.keysets ?? []).map((keySet) => ({
    id: keySet.id,
    name: keySet.name,
    type: keySet.type,
    environmentId: keySet.environmentId,
    environmentName: keySet.environmentName,
    chipMode: RkiKeySetChipMode.Default,
  }));
}
